import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import esCommon from './locales/es/common.json';
import esHiring from './locales/es/hiring.json';
import esPayment from './locales/es/payment.json';
import esMandate from './locales/es/mandate.json';
import esBilling from './locales/es/billing.json';
import esPortal from './locales/es/portal.json';
import esRegularizacion from './locales/es/regularizacion.json';
import esSite from './locales/es/site.json';
import esCrm from './locales/es/crm.json';

import enCommon from './locales/en/common.json';
import enHiring from './locales/en/hiring.json';
import enPayment from './locales/en/payment.json';
import enMandate from './locales/en/mandate.json';
import enBilling from './locales/en/billing.json';
import enPortal from './locales/en/portal.json';
import enRegularizacion from './locales/en/regularizacion.json';
import enSite from './locales/en/site.json';
import enCrm from './locales/en/crm.json';

import frCommon from './locales/fr/common.json';
import frHiring from './locales/fr/hiring.json';
import frPayment from './locales/fr/payment.json';
import frMandate from './locales/fr/mandate.json';
import frBilling from './locales/fr/billing.json';
import frPortal from './locales/fr/portal.json';
import frRegularizacion from './locales/fr/regularizacion.json';
import frSite from './locales/fr/site.json';
import frCrm from './locales/fr/crm.json';

import ptCommon from './locales/pt/common.json';
import ptSite from './locales/pt/site.json';

import arRegularizacion from './locales/ar/regularizacion.json';
import arSite from './locales/ar/site.json';

export const supportedLanguages = ['es', 'en', 'fr', 'pt', 'ar'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

export const RTL_LANGUAGES: readonly SupportedLanguage[] = ['ar'] as const;

export function isRTL(lang: string): boolean {
  return (RTL_LANGUAGES as readonly string[]).includes(lang);
}

i18n.use(initReactI18next).init({
  resources: {
    es: {
      common: esCommon,
      hiring: esHiring,
      payment: esPayment,
      mandate: esMandate,
      billing: esBilling,
      portal: esPortal,
      regularizacion: esRegularizacion,
      site: esSite,
      crm: esCrm,
    },
    en: {
      common: enCommon,
      hiring: enHiring,
      payment: enPayment,
      mandate: enMandate,
      billing: enBilling,
      portal: enPortal,
      regularizacion: enRegularizacion,
      site: enSite,
      crm: enCrm,
    },
    fr: {
      common: frCommon,
      hiring: frHiring,
      payment: frPayment,
      mandate: frMandate,
      billing: frBilling,
      portal: frPortal,
      regularizacion: frRegularizacion,
      site: frSite,
      crm: frCrm,
    },
    pt: {
      common: ptCommon,
      site: ptSite,
    },
    ar: {
      regularizacion: arRegularizacion,
      site: arSite,
    },
  },
  lng: 'es',
  fallbackLng: 'es',
  ns: ['common', 'hiring', 'payment', 'mandate', 'billing', 'portal', 'regularizacion', 'site', 'crm'],
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
